import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { ToastService } from 'src/app/services/toast.service';
import { MerchantService } from 'src/app/services/merchant.service';

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.css'],
})
export class ConfirmComponent implements OnInit {
  constructor(
    public service: MerchantService,
    public activatedRoute: ActivatedRoute,
    public toast: ToastService,
    public location: Location
  ) {}

  model: any;

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe((params) => {
      let code = params.get('code');
      console.log('code', code);

      this.service.getById(code).subscribe((data) => {
        this.model = data;

        console.log('arg', data);
        if (this.model) {
          let current_datetime = new Date();
          let formatted_date =
            current_datetime.getFullYear() +
            '-' +
            (current_datetime.getMonth() + 1) +
            '-' +
            current_datetime.getDate();

          let arg: any = {
            code: code,
            confirmedEmail: formatted_date,
          };
          this.service.update(arg);
        }
      });
    });
  }
}
